// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file deeplink/deeplink_request.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file deeplink/deeplink_request.proto.
 */
export const file_deeplink_deeplink_request: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Ch9kZWVwbGluay9kZWVwbGlua19yZXF1ZXN0LnByb3RvEhRjb20uZ2VtLmJmZi5jb250cmFjdCIhChJHZXREZWVwTGlua1JlcXVlc3QSCwoDdXJsGAEgASgJIi8KHVJlZnJlc2hEZWVwTGlua0RldGFpbHNSZXF1ZXN0Eg4KBmNoYXRJZBgBIAEoAyJBChxDcmVhdGVNZXNzYWdlRGVlcExpbmtSZXF1ZXN0Eg4KBmNoYXRJZBgBIAEoAxIRCgltZXNzYWdlSWQYAiABKANCGAoUY29tLmdlbS5iZmYuY29udHJhY3RQAWIGcHJvdG8z'
  );

/**
 * @generated from message com.gem.bff.contract.GetDeepLinkRequest
 */
export type GetDeepLinkRequest = Message<'com.gem.bff.contract.GetDeepLinkRequest'> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;
};

/**
 * Describes the message com.gem.bff.contract.GetDeepLinkRequest.
 * Use `create(GetDeepLinkRequestSchema)` to create a new message.
 */
export const GetDeepLinkRequestSchema: GenMessage<GetDeepLinkRequest> =
  /*@__PURE__*/
  messageDesc(file_deeplink_deeplink_request, 0);

/**
 * @generated from message com.gem.bff.contract.RefreshDeepLinkDetailsRequest
 */
export type RefreshDeepLinkDetailsRequest =
  Message<'com.gem.bff.contract.RefreshDeepLinkDetailsRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.RefreshDeepLinkDetailsRequest.
 * Use `create(RefreshDeepLinkDetailsRequestSchema)` to create a new message.
 */
export const RefreshDeepLinkDetailsRequestSchema: GenMessage<RefreshDeepLinkDetailsRequest> =
  /*@__PURE__*/
  messageDesc(file_deeplink_deeplink_request, 1);

/**
 * @generated from message com.gem.bff.contract.CreateMessageDeepLinkRequest
 */
export type CreateMessageDeepLinkRequest =
  Message<'com.gem.bff.contract.CreateMessageDeepLinkRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: int64 messageId = 2;
     */
    messageId: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.CreateMessageDeepLinkRequest.
 * Use `create(CreateMessageDeepLinkRequestSchema)` to create a new message.
 */
export const CreateMessageDeepLinkRequestSchema: GenMessage<CreateMessageDeepLinkRequest> =
  /*@__PURE__*/
  messageDesc(file_deeplink_deeplink_request, 2);
